import React from 'react'
import { type ActionMenuItem } from '../types/common.types'

type Props = {
    items: ActionMenuItem[]
}

export default function MoreOptionsMenu({items}: Props) {
    const [show, setShow] = React.useState(false);
    const menuRef = React.useRef<HTMLDivElement>(null);
    const isToggling = React.useRef(false);

    const iconSize = React.useMemo(() => {
        let max = 0;
        items.forEach((i: ActionMenuItem) => {
            if (i.iconSize != null && i.iconSize > max){
                max = i.iconSize;
            }
        })
        return max == 0 ? 14 : max;
    }, [items])

    React.useEffect(() => {
        const doHide = () => {
            if (!isToggling.current){
                hideMenu();
            }
            isToggling.current = false;
        }
        window.addEventListener('moreOptionsMenuOpen', doHide);

        const handleClick = (event: MouseEvent) => {
            if (!show){
                return;
            }
            const clickedElement = event.target;
            if (clickedElement instanceof Element){
                if (!menuref.current!.contains(clickedElement)){
                    setShow(false);
                }
            }
        }
        document.addEventListener('click', handleClick);

        return (() => {
            window.removeEventListener('moreOptionsMenuOpen', doHide);
            document.removeEventListener('click', handleClick);
        })
    }, [show])
        
    const toggleMenu = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setTimeout(() => {
            isToggling.current = true;
            event.preventDefault();
            setShow(!show);
            const showEvent = new Event('moreOptionsMenuOpen');
            window.dispatchEvent(showEvent);
        }, 0)
    }

    const hideMenu = () => {
        setShow(false);
    }

    let itemElements: React.JSX.Element[] = [];
    let iconSizeStr = iconSize.toString() + 'px';
    items.forEach((item: ActionMenuItem) => {
        if (item.show == false){
            return;
        }
        itemElements.push(
            <a href="#" key={item.label} onClick={
                (event: React.MouseEvent<HTMLAnchorElement>) => {event.preventDefault(); item.action(); setShow(false);}
            }>
                <li className='more-options-menu-item'>
                    <div style={{display: 'flex'}}>
                        <div style={{width: iconSizeStr, height: iconSizeStr, marginRight: '4px'}}>
                            {item.iconSrc && (
                                <img src={item.iconSrc} style={{width: iconSizeStr, height: iconSizeStr}} />
                            )}
                        </div>
                        {item.label}
                    </div>
                </li>
            </a>
        )
    });

    let menuClass = 'more-options-menu box';
    if (!show){
        menuClass += ' hidden';
    }

    return (
        <div className='more-options-menu-container'>
            <div className='more-options-menu-button'>
                <a href="#" onClick={toggleMenu}>
                    <img src="/svgs/more-options.svg" />
                </a>
            </div>
            <div ref={menuRef} className={menuClass}>
                <ul className='more-options-menu-items'>
                    {itemElements}
                </ul>
            </div>
        </div>
    )
}